class CustomSwiper extends HTMLElement {
  constructor() {
    super();
    this.slidesPerView_pc = Number(this.getAttribute("data-row")) || 4
    this.slidesPerView_table = Number(this.getAttribute("data-table-row")) || 3
    this.slidesPerView_m = Number(this.getAttribute("data-rowm")) || 2
    this.has_button = this.getAttribute("data-button") == "true"
    this.has_pagination = this.getAttribute("data-pagination") == "true"
    this.is_free = this.getAttribute("data-free") == "true"
    
  }
   connectedCallback() {
    setTimeout(() => this.initSwiper(), 0);
  }

  initSwiper(){
    const nextEl = this.querySelector('.swiper-button-next');
    const prevEl = this.querySelector('.swiper-button-prev');
    const pagination = this.querySelector('.swiper-pagination');
    const swiperContainer = this.querySelector('.custom-swiper-container') || this;
    const slideCount = this.querySelectorAll('.swiper-slide').length;
    const config = {
      slidesPerView: this.slidesPerView_m,
      spaceBetween: 10,
      allowTouchMove: slideCount > this.slidesPerView_m,
      breakpoints: {
        768: {
          slidesPerView: this.slidesPerView_table,
          spaceBetween: 20,
          allowTouchMove: slideCount > this.slidesPerView_table
        },
        1280:{
              slidesPerView: this.slidesPerView_pc,
          spaceBetween: 20,
          allowTouchMove: slideCount > this.slidesPerView_pc
        }
      }
    };
    if (this.has_button && nextEl && prevEl) {
      config.navigation = {
        nextEl,
        prevEl
      };
    }
     if (this.has_pagination && pagination) {
      config.pagination= {
        el: pagination
      }
    }
     if (this.is_free) {
      config.pagination= {
        freeMode: true
      }
    }
    new Swiper(swiperContainer, config);
  }

}

customElements.define('custom-swiper', CustomSwiper)
